/* eslint-disable import/prefer-default-export */

import _ from 'lodash'
import { createSelector } from 'reselect'

const getResidentDocs = (_state, props) => {
  const {
    router: {
      params: { id }
    }
  } = props
  const residentDocs = _.filter(_state.data.documents, { resident: id })
  return residentDocs
}

const getResidentCareplans = (_state, props) => {
  const {
    router: {
      params: { id }
    }
  } = props
  const residentCarePlans = _.filter(_state.data['care-plans'], {
    resident: id
  })
  return residentCarePlans
}

export const carePlanDocumentSelector = createSelector(
  [getResidentDocs, getResidentCareplans],
  (docs, carePlans) => {
    const residentDocuments = docs
    if (residentDocuments) {
      _?.forEach(residentDocuments, (resDoc, i) => {
        const docID = resDoc.id
        _?.forEach(carePlans, (carePlan) => {
          const carePlanDocuments = carePlan.documents
          if (carePlanDocuments.length > 0) {
            _?.forEach(carePlanDocuments, (doc) => {
              if (doc === docID) {
                const carePlanName =
                  carePlan.customName || carePlan.carePlanAdl.name
                residentDocuments[i] = { ...resDoc, carePlanName }
              }
            })
          }
        })
      })
      return residentDocuments
    }
    return null
  }
)
